import React, { useState } from "react";

import { Dialog } from 'primereact/dialog';
import servicioObjetos from "../../servicio/ServicioObjetos";

export const ModalResponseAuthIdseImms = (props) => {

    const { mostrar, funcionCerrar, objetoResponseAuth } = props;

    return (<div>
        <Dialog appendTo={document.body} header="Respuesta https://idse.imss.gob.mx/imss/"
            visible={mostrar} style={{ width: '70%' }} modal={true} onHide={funcionCerrar}>
            <div className="card card-w-title">
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-12">
                        <h2>Validación de los certificados proporcionados en el portal https://idse.imss.gob.mx/imss/</h2>
                        <p>Estimado usuario, parece ser que la información proporcionada <strong>(USUARIO, CONTRASEÑA, .PFX) cuando se contectará mediante .PFX</strong> 
                        &nbsp;o bien <strong>(RFC_EMPRESA, CONTRASEÑA_EFIRMA y EFIRMA (.cer y .key)) cuando se usará la EFIRMA o FIEL</strong> no son correctos tiene que revisar su información para poder registrar la empresa.</p>
                        <p>
                            Es probable que el portal <strong>https://idse.imss.gob.mx/imss/</strong> se ecuentre saturado y posiblemente este sea el problema, si el error persiste intente más tarde.
                        </p>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <h3>Mensaje obtenido desde el portal del IDSE:</h3>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <h3><strong>{objetoResponseAuth.mensajeErrorAutenticacion}</strong></h3>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <h3>Registro Patronal Capturado:</h3>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <h3><strong>{objetoResponseAuth.registroPatronal}</strong></h3>
                    </div>

                    <div className="p-col-12 p-md-12">
                        <h3>Registros Patronales Encontrados en el portal  https://idse.imss.gob.mx/imss:</h3>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <h3><strong>{servicioObjetos.esObjetoVacio(objetoResponseAuth.registroPatronalesEncontrados) ?"":objetoResponseAuth.registroPatronalesEncontrados.toString()}</strong></h3>
                    </div>

                    <div className="p-col-12 p-md-12">
                        <h3>Los certificados registrados le corresponden al RP registrado:</h3>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <h3><strong>{objetoResponseAuth.certificadosCorrespondenAlRegistroPatronal ? "Sí" : "No, parece ser que los certificados que quiere usar no le pertenecen al registro patronal que quiere utilizar"}</strong></h3>
                        {
                            !servicioObjetos.esObjetoVacio(objetoResponseAuth.registroPatronalesEncontrados) ?
                                <>
                                    <h3>Usted ha capturado el Registro Patronal <strong>{objetoResponseAuth.registroPatronal}</strong> y el imss reporta los siguientes Registros Patronales:</h3>
                                    <h3><strong>{objetoResponseAuth.registroPatronalesEncontrados.toString()}</strong></h3>
                                </> : null
                        }
                    </div>

                    <div className="p-col-12 p-md-12">
                        <h3>Evidencia IMSS:</h3>
                    </div>
                    <div className="p-col-12 p-md-12">
                        {!servicioObjetos.esObjetoVacio(objetoResponseAuth.evidenciaNoUtenticadoDataResponse) ?
                            <iframe
                                title="myBook"
                                src={'data:text/html;charset=utf-8,' + escape(objetoResponseAuth.evidenciaNoUtenticadoDataResponse)}
                                height="720"
                                width="1280"
                                frameBorder="0"
                                scrolling="no"
                                allowFullScreen={true}
                            ></iframe>
                            : null
                        }
                    </div>

                </div>
            </div>
        </Dialog>
    </div>);
}